import i18n from "../../config/i18n";
import ServiceFactory from "../../framework/factory/ServiceFactory";
import ConfigHelper from "../../helper/ConfigHelper";
import LocalStorageHelper from "../../helper/LocalStorageHelper";
import ConfigResourceModel from "../../resource-model/config/ConfigResourceModel";
import CoreService from "../CoreService";

export class ConfigService extends CoreService {
    static className = 'ConfigService';
    resourceModel = ConfigResourceModel;

    /**
     * Save all config to Local storage
     * @param data
     */
    saveToLocalStorage(data) {
        LocalStorageHelper.set(LocalStorageHelper.CONFIG, JSON.stringify(data));
    }

    /**
     * get config from local storage
     * @returns {*|string}
     */
    getConfigFromLocalStorage() {
        return LocalStorageHelper.get(LocalStorageHelper.CONFIG);
    }

    /**
     * Change language
     * @param locale
     */
    changeLanguage(locale) {
        if (!locale) {
            locale = ConfigHelper.getLocaleCode();
        }

        i18n.init({
            fallbackLng: false,
            lng: locale.toLowerCase(),

            // have a common namespace used around the full app
            ns: ['translations'],
            defaultNS: 'translations',
            nsSeparator: false,
            keySeparator: false,

            debug: false,

            interpolation: {
                escapeValue: false, // not needed for react!!
            },

            backend: {
                loadPath: '/locales/{{lng}}/{{ns}}.json'
            },

            react: {
                wait: true,
                withRef: false,
                bindI18n: 'languageChanged loaded',
                bindStore: 'added removed',
                nsMode: 'default'
            }
        });
    }
}
/** @type ConfigService */
let configService = ServiceFactory.get(ConfigService);

export default configService;




// WEBPACK FOOTER //
// ./src/service/config/ConfigService.js